<template>
    <!-- Main Sidebar Container -->
    <aside class="main-sidebar elevation-4 sidebar-dark-marron">
        <a href="#" class="brand-link animation__shake wow fadeInDown"
            style="align-items: center;position: absolute;top: 25px;" data-widget="pushmenu" role="button">
            <center>
                <i class="fas fa-align-right text-white"></i>&nbsp;<img src="../../../assets/img/logojateng.png"
                    alt="Admin Logo" class="animation__shake wow fadeInDown" style="opacity: .8;height: 35px;">
            </center>
        </a>
        <!-- Sidebar -->
        <div class="sidebar wow fadeInLeft">
            <!-- Sidebar Menu -->
            <nav class="mt-2">
                <ul class="nav nav-pills nav-sidebar flex-column nav-flat" data-widget="treeview" role="menu"
                    data-accordion="false">
                    <li class="nav-item">&nbsp;</li>
                    <li class="nav-item">&nbsp;</li>
                    <li class="nav-item">
                        <router-link to="/Dashboard"
                            :class="[(route.name == 'Dashboard' ? 'nav-link active' : 'nav-link')]" id="Dashboard"><i
                                class="nav-icon fas fa-chart-line"></i>
                            <p style="font-weight: bolder;">DASHBOARD</p>
                        </router-link>
                    </li>
                    <li :class="[((route.name == 'LayerPeta' || route.name == 'Profil'
                        || route.name == 'ProsesProfil' || route.name == 'Dokumen') ? 'nav-item menu-open' : 'nav-item')]">
                        <a href="#" :class="[((route.name == 'LayerPeta' || route.name == 'Profil'
                            || route.name == 'ProsesProfil' || route.name == 'Dokumen') ? 'nav-link active' : 'nav-link')]">
                            <i class="nav-icon fas fa-database"></i>
                            <p style="font-weight: bolder;">
                                DATA SIMFAST
                                <i class="right fas fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="(leveluser == 1)">
                                <router-link to="/Profil"
                                    :class="[((route.name == 'Profil' || route.name == 'ProsesProfil') ? 'nav-link active' : 'nav-link')]"
                                    id="Profil"><i class="nav-icon far fa-address-card text-warning2"></i>
                                    <p class="text-warning2" style="font-size: small;">PROFIL INFRASTRUKTUR</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="(leveluser == 1)">
                                <router-link to="/LayerPeta"
                                    :class="[((route.name == 'LayerPeta' || route.name == 'ProsesLayerPeta') ? 'nav-link active' : 'nav-link')]"
                                    id="LayerPeta"><i class="nav-icon fas fa-map-marked-alt text-warning2"></i>
                                    <p class="text-warning2" style="font-size: small;">PETA SIG IT</p>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/Dokumen"
                                    :class="[((route.name == 'Dokumen' || route.name == 'ProsesDokumen') ? 'nav-link active' : 'nav-link')]"
                                    id="Dokumen"><i class="nav-icon far fa-file-pdf text-warning2"></i>
                                    <p class="text-warning2" style="font-size: small;">DOKUMEN INFRASTRUKTUR</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li :class="[((route.name == 'User' || route.name == 'ProsesUser' || route.name == 'InfoBeranda'
                        || route.name == 'ProsesInfoBeranda' || route.name == 'Slider'
                        || route.name == 'ProsesSlider') ? 'nav-item menu-open' : 'nav-item')]"
                        v-if="(leveluser == 1)">
                        <a href="#" :class="[((route.name == 'User' || route.name == 'ProsesUser' || route.name == 'InfoBeranda'
                            || route.name == 'ProsesInfoBeranda') ? 'nav-link active' : 'nav-link')]" v-if="(leveluser == 1)">
                            <i class="nav-icon fas fa-cog"></i>
                            <p style="font-weight: bolder;">
                                PENGATURAN
                                <i class="right fas fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="(leveluser == 1)">
                                <router-link to="/Slider"
                                    :class="[((route.name == 'Slider' || route.name == 'ProsesSlider') ? 'nav-link active' : 'nav-link')]"
                                    id="Slider"><i class="nav-icon fas fa-photo-video text-warning2"></i>
                                    <p class="text-warning2" style="font-size: small;">SLIDER GAMBAR</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="(leveluser == 1)">
                                <router-link to="/InfoBeranda"
                                    :class="[((route.name == 'InfoBeranda' || route.name == 'ProsesInfoBeranda') ? 'nav-link active' : 'nav-link')]"
                                    id="InfoBeranda"><i class="nav-icon fas fa-box text-warning2"></i>
                                    <p class="text-warning2" style="font-size: small;">INFO BERANDA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="(leveluser == 1)">
                                <router-link to="/User"
                                    :class="[((route.name == 'User' || route.name == 'ProsesUser') ? 'nav-link active' : 'nav-link')]"
                                    id="User"><i class="nav-icon fas fa-user-friends text-warning2"></i>
                                    <p class="text-warning2" style="font-size: small;">PENGATURAN PENGGUNA</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <a href="#" class="nav-link" @click="keluar()">
                            <i class="nav-icon fas fa-sign-out-alt"></i>
                            <p style="font-weight: bolder;">KELUAR / LOGOUT</p>
                        </a>
                    </li>
                    <li>&nbsp;</li>
                </ul>
            </nav>
            <!-- /.sidebar-menu -->
        </div>
        <!-- /.sidebar -->
    </aside>
</template>

<script>
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
export default {
    components: {
        swal
    },
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    data() {
        return {
            tahun: new Date().getFullYear(),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            folderawal: encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
        };
    },
    methods: {
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                localStorage.removeItem('tokensistem');
                localStorage.removeItem('usistem');
                localStorage.removeItem('lsistem');
                localStorage.removeItem('nmlsistem');
                localStorage.removeItem('emlsistem');
                localStorage.removeItem('nmusistem');
                localStorage.removeItem('tsistem');
                localStorage.removeItem('orsistem');
                localStorage.removeItem('bdlsistem');
                localStorage.removeItem('sbdsistem');
                localStorage.removeItem('jbtsistem');
            }
        },
        pindahawalnya1() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data/" + bytes);
        },
        pindahawalnya3() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data3/" + bytes);
        },
        pindahawalnya4() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data4/" + bytes);
        },
        pindahawalnya5() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data5/" + bytes);
        },
        pindahawalnya6() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data6/" + bytes);
        },
        pindahawalnya7() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data7/" + bytes);
        },
        keluar() {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Keluar Aplikasi?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#15B9D9",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Keluar"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.ClearlocalStorage();
                }
            });

            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        if ((localStorage.getItem("tokensistem") == null)) {
            window.location.replace("/Login");
        }
    }
}
</script>

<style></style>